import { useEffect, useRef, useMemo, type FC } from "react";
import { MagnifyingGlass } from "@/components/icons";
import EventLink from "@/components/Link/EventLink/EventLink";
import Footer from "./Footer";
import MainContent from "./MainContent";
import { ElementType } from "@/constants/tagular/main";

type CategoryLink = {
  label: string;
  url: string;
};

interface Props {
  categoryLinks?: CategoryLink[];
  location?: string;
}

const NoResultsState: FC<Props> = ({
  categoryLinks = [],
  location = "embedded-search",
}) => {
  return (
    <MainContent>
      <div className="flex flex-col justify-center items-start gap-y-4 pt-4 pb-6 py-4">
        <span className="text-md font-bold text-[#00262B] flex px-4 justify-center items-start gap-2.5 self-stretch">
          <MagnifyingGlass /> No results found
        </span>
        <ul className="flex justify-center items-start gap-4 self-stretch list-none text-putty-700 flex-wrap md:flex-nowrap">
          <li className="text-xs font-bold before:content-['•'] before:mr-1.5 before:inline-block">
            Check your spelling
          </li>
          <li className="text-xs font-bold before:content-['•'] before:mr-1.5 before:inline-block">
            Use more general terms
          </li>
          <li className="text-xs font-bold before:content-['•'] before:mr-1.5 before:inline-block">
            Browse by category below
          </li>
        </ul>
      </div>
      <Footer>
        <ul className="flex py-4 justify-center items-center self-stretch gap-6 flex-wrap md:flex-nowrap">
          <li className="font-bold text-xs">Browse by category</li>
          {categoryLinks.map((link, index) => (
            <li key={link.url} className="text-xs">
              <EventLink
                href={link.url}
                element_type={ElementType.Entry}
                html_id="trending-now"
                location={location}
                text={link.label}
                position={(index + 1).toString()}
                class_name="underline"
              />
            </li>
          ))}
        </ul>
      </Footer>
    </MainContent>
  );
};

export default NoResultsState;
